import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IndexFundNavHistoryTab } from '../IndexFundNavList/IndexFundNavHistoryTab';
import { locations } from '../../routes/locations';

export function IndexFundNavHistory() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const fundId = Number(id);

  if (!id || Number.isNaN(fundId)) {
    return (
      <Container component="main" maxWidth="xl">
        <Typography color="error">Invalid fund id</Typography>
      </Container>
    );
  }

  return (
    <Container component="main" maxWidth="xl">
      <Box display="flex" alignItems="center" mb={2}>
        <Button startIcon={<ArrowBackIcon />} variant="text" onClick={() => navigate(locations.indexFund(fundId))}>
          Back to Fund
        </Button>
      </Box>
      <Typography variant="h5" gutterBottom>
        NAV History
      </Typography>
      <IndexFundNavHistoryTab fundId={fundId} />
    </Container>
  );
}
